import moment from "moment/moment";
import {KeyConstant} from "../constant/keyConstant";

export const mapTag = (type, startDate , endDate) => {

    let dateDiff = moment(endDate).diff(moment(startDate), 'days') + 1

    switch (type){
        case KeyConstant.TODAY:
            return "1 ngày hôm nay"
        case KeyConstant.YESTERDAY:
            return "1 ngày hôm qua"
        case KeyConstant.THIS_WEEK:
            return "1 tuần này"
        case KeyConstant.LAST_WEEK:
            return "1 tuần trước"
        case KeyConstant.THIS_MONTH:
            return "1 tháng này"
        case KeyConstant.LAST_MONTH:
            return "1 tháng trước"
        case KeyConstant.SEVEN_DAYS_AGO:
            return "7 ngày trước"
        case KeyConstant.THIRTY_DAYS_AGO:
            return "28 ngày trước"
        case KeyConstant.NINETY_DAYS_AGO:
            return "90 ngày trước"
        default :
            return dateDiff + " ngày"
    }
}
